// PRODUCT
export const IS_VIVUS = import.meta.env.VITE_PRODUCT !== 'vivusonline';

export const DEFAULT_VIVUS_TERM = 27;

// PHONE + EMAILS

export const PHONE_VIVUS = '91 290 77 88';
export const PHONE_LINK_VIVUS = '+34912907788';

export const EMAIL_VIVUS = 'info@vivus.es';

// DASHBOARD ROUTES
export const LOGIN_VIVUS_PATH = '/login';
